export default {
  NAVBAR_HOME_ICON: 'Navbar > Home Icon',
  NAVBAR_CONTACTS_ICON: 'Navbar > Contacts Icon',
  NAVBAR_SETTINGS_ICON: 'Navbar > Settings Icon',
  NAVBAR_CAMPAIGNS_ICON: 'Navbar > Campaigns Icon',

  DASHBOARD_DATE_PERIOD_ALL_TIME: 'Dashboard > Date Periods > All Time',
  DASHBOARD_DATE_PERIOD_TODAY: 'Dashboard > Date Periods > Today',
  DASHBOARD_DATE_PERIOD_1W: 'Dashboard > Date Periods > 1W',
  DASHBOARD_DATE_PERIOD_1M: 'Dashboard > Date Periods > 1M',
  DASHBOARD_DATE_PERIOD_MTD: 'Dashboard > Date Periods > MTD',
  DASHBOARD_DATE_PERIOD_YTD: 'Dashboard > Date Periods > YTD',
  DASHBOARD_DATE_PERIOD_1Y: 'Dashboard > Date Periods > 1Y',
  DASHBOARD_DATE_PERIOD_CUSTOM: 'Dashboard > Date Periods > Custom',
  DASHBOARD_DISCOUNT_REDEMPTION_NEW_CUSTOMER: 'Dashboard > Discount Redemptions > New Customers',
  DASHBOARD_DISCOUNT_REDEMPTION_RETURNING_CUSTOMER: 'Dashboard > Discount Redemptions > Returning Customers',
  DASHBOARD_DISCOUNT_REDEMPTION_REFERRERS_CUSTOMER: 'Dashboard > Discount Redemptions > Referrers Customers',

  DASHBOARD_CREDIT_REDEEMED_NEW_CUSTOMER: 'Dashboard > Credit Redeemed > New Customers',
  DASHBOARD_CREDIT_REDEEMED_RETURNING_CUSTOMER: 'Dashboard > Credit Redeemed > Returning Customers',
  DASHBOARD_CREDIT_REDEEMED_REFERRERS_CUSTOMER: 'Dashboard > Credit Redeemed > Referrers Customers',

  DASHBOARD_CREDIT_GRANTED_NEW_CUSTOMER: 'Dashboard > Credit Granted > New Customers',
  DASHBOARD_CREDIT_GRANTED_RETURNING_CUSTOMER: 'Dashboard > Credit Granted > Returning Customers',
  DASHBOARD_CREDIT_GRANTED_REFERRERS_CUSTOMER: 'Dashboard > Credit Granted > Referrers Customers',

  DASHBOARD_DISCOUNTS_GRANTED_NEW_CUSTOMER: 'Dashboard > Discounts Granted > New Customers',
  DASHBOARD_DISCOUNTS_GRANTED_RETURNING_CUSTOMER: 'Dashboard > Discounts Granted > Returning Customers',
  DASHBOARD_DISCOUNTS_GRANTED_REFERRERS_CUSTOMER: 'Dashboard > Discounts Granted > Referrers Customers',
  DASHBOARD_CONTACT_WELCOMED: 'Dashboard > Contacts Welcomed',
  DASHBOARD_DISCOUNT_EXPIRED_WITHOUT_REDEMPTION: 'Dashboard > Discounts Expired Without Redemption',

  TOP_10_REFERERS_DISCOUNT_ACCEPTED: 'Top 10 Referrers > Total Ref Discount Accepted',
  TOP_10_REFERERS_DISCOUNT_REDEEMED: 'Top 10 Referrers > Total Ref Discount Redeemed',

  CONTACTS_ADD_CONTACTS: 'Contacts > Add Contacts',
  CONTACTS_SEARCH: 'Contacts > Search',
  CONTACTS_SEND_WELCOMES: 'Contacts > Send Welcomes',
  CONTACTS_DOWNLOAD_CSV: 'Contacts > Download CSV',
  CAMPAIGN_DOWNLOAD_CSV: 'Campaigns > Download CSV',
  CONTACTS_TOTAL_REF_DISCOUNT_ACCEPTED: 'Contacts > Total Ref Discounts Accepted',
  CONTACTS_TOTAL_REF_DISCOUNT_REDEEMED: 'Contacts > Total Ref Discounts Redeemed',
  CONTACTS_FILTERED_BY_TAGS: 'Contacts > Contacts Filtered By Tags',

  SETTINGS_BUSINESS_PROFILE: 'Settings > Business Profile',
  SETTINGS_USER_PROFILE: 'Settings > User Profile',
  SETTINGS_CONFIGURATIONS: 'Settings > Configurations',
  SETTINGS_INTEGRATION: 'Settings > Integration',
  SETTINGS_TEAM: 'Settings > Team',
  SETTINGS_BILLINGS: 'Settings > Billing',
  SETTINGS_SELF_OPT_IN: 'Settings > Self Opt-In',
  SETTINGS_SMS_CAMPAIGNS: 'Settings > SMS Campaigns',
  SETTINGS_CONTACT_TAGS: 'Settings > Contact Tags',
  CAMPAIGNS_NEW_BUTTON: 'Campaigns > New Campaign Button',
  CAMPAIGNS_REPLICATE_BUTTON: 'Campaigns > Replicate Campaign Button',
  CAMPAIGNS_EDIT_BUTTON: 'Campaigns > Edit Campaign Button',
};

// CAMPAIGNS_VIEW_CAMPAIGN_DETAILS: "Campaigns > View Campaign Details",
// CAMPAIGNS_PREVIEW_CAMPAIGN_BEFORE_SEND: "Campaigns > Test Campaign Sent",
// CAMPAIGNS_SENT_WITH_REFERRAL_TEXT: "Campaigns > Campaign Sent With Referral Text",
// CAMPAIGNS_SENT_WITH_TRACK_CONVERSIONS: "Campaigns > Campaign Sent With Track Campaign Conversions",
// CAMPAIGNS_SENT_MMS_CAMAPAIGN: "Campaigns > Sent MMS Campaign",
// CAMPAIGNS_SENT_SMS_CAMPAIGN: "Campaigns > Sent SMS Campaign",
// CAMPAIGNS_EDIT_BUTTON: "Campaigns > Edit Campaign Button",
